export default "__VITE_ASSET__ddca0470__"